module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAAyElEQVQ4T4WSYRXCMAyE7yRgAQsggUnAAkgACSABJDAJTAKzgAUkHO9Gtxega/OnXdt9uVxCSUsAK3yiJ/lM++oiaQFgMz4k2TId3hP0BaAh2VdpACTdAGzT2yPJM/2Rga5rSiVdAOwizPsBGKAPALbACq3Uiv9iDvYFTFB76fLtTUey+aWVYH/ADPRKch+qyJYZk04lx0NJ7pyVOgaza8qmTs91U9IBwCndd2E8hgRz/2UVhhIjdFJbGqkiMHlqqGetLSkbk7wB3ABYC6a97E8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/down_icon_white.png
// module id = txG+
// module chunks = 13